export const SET_CANCELLATION_REASON = 'cancellationReason/setCancellationReason.js';

export default payload => ({
  type: SET_CANCELLATION_REASON,
  error: false,
  payload,
});
